import { render, staticRenderFns } from "./ContactBook.vue?vue&type=template&id=3af2fa4e&scoped=true"
import script from "./ContactBook.vue?vue&type=script&lang=js"
export * from "./ContactBook.vue?vue&type=script&lang=js"
import style0 from "./ContactBook.vue?vue&type=style&index=0&id=3af2fa4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af2fa4e",
  null
  
)

export default component.exports